
import { NgModule } from '@angular/core';
import { SharedModule } from 'src/app/shared/shared.module';
import { CommonModule } from '@angular/common';

import { NgxSpinnerModule } from 'ngx-spinner';

import { UtilService } from 'src/app/shared/services/util.service';
import { RegistroCiudadanoUACRouting } from './registro-ciudadano-UAC.routing';
import { RegistroCiudadanoUACCOMPONENT } from './registro-ciudadano-UAC.component';
@NgModule({
    declarations: [
        RegistroCiudadanoUACCOMPONENT
    ],
    imports: [
        NgxSpinnerModule,
        SharedModule,
        CommonModule,
        RegistroCiudadanoUACRouting
    ],
    entryComponents: [

    ]
    , providers: [
        UtilService]
})

export class RegistroCiudadanoUACModule { }
